<template>
  <div>创建设置</div>
</template>

<script>
import { getGeneral, setGeneral } from '@/api/setting/generalSettings'
export default {
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      const data = await getGeneral()
      if (data) {
        this.form = data
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
